import React from "react";

export const ScreenContext = React.createContext();

export function ScreenContextProvider({
  initState = { totalScreen: 0, zMap: {} },
  children = null,
}) {
  const [store, dispatch] = React.useReducer((state, { type, value }) => {
    switch (type) {
      case "init-z-index":
        return {
          ...state,
          totalScreen: state.totalScreen + 1,
          zMap: {
            ...state.zMap,
            [value.screen]: { screen: value.screen, z: state.totalScreen + 1 },
          },
        };
      case "set-z-index":
        return { ...state, zMap: value };
      default:
        return initState;
    }
  }, initState);

  return (
    <ScreenContext.Provider value={{ dispatch, store }}>
      {children}
    </ScreenContext.Provider>
  );
}

export function WithScreenContextProvider(WrappedComponent) {
  return (props) => {
    return (
      <ScreenContextProvider>
        <WrappedComponent {...props} />
      </ScreenContextProvider>
    );
  };
}

export default WithScreenContextProvider;
